import { io } from 'socket.io-client';
import { SOCKET_ORIGIN } from 'src/backend/common';
import { DASHBOARD_VERSION_LATEST_KEY } from 'src/utils/dashboardVersion';

let cachedIO;

const SocketIO = {
  init: function () {
    cachedIO = io(SOCKET_ORIGIN, {
      transports: ['websocket', 'polling'], // use WebSocket first, if available
    });

    cachedIO.on('dashboard-update', ({ version }) => {
      try {
        if (typeof version === 'number') {
          window.localStorage.setItem(
            DASHBOARD_VERSION_LATEST_KEY,
            String(version)
          );
          window.dispatchEvent(
            new CustomEvent('latest-dashboard-version', {
              detail: { latestVersion: version },
            })
          );
          window.dispatchEvent(
            new CustomEvent('socket-dashboard-update', {
              detail: { latestVersion: version },
            })
          );
        }
      } catch (_) {
        // ignore client storage errors
      }
    });
  },
  getIO: function () {
    if (!cachedIO) {
      throw new Error("Can't get io instance before calling .init()");
    }
    return cachedIO;
  },
};

export default SocketIO;
